export default "__VITE_ASSET__cb9207bb__"